import axios from "axios";
import React, { useEffect, useState } from "react";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

const Testimonial = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [testimonials,setTestimonials] = useState([]);

    const CACHE_KEY = 'testimonialsCache';
    const CACHE_TIME_KEY = 'testimonialsCacheTime';
    const CACHE_DURATION = 30 * 60 * 1000; // ৩০ মিনিট মিলিসেকেন্ডে

    useEffect(() => {
        const cachedTestimonials = localStorage.getItem(CACHE_KEY);
        const cacheTime = localStorage.getItem(CACHE_TIME_KEY);
        const now = new Date().getTime();

        if (cachedTestimonials && cacheTime && now - cacheTime < CACHE_DURATION) {
            // Cache is valid
            setTestimonials(JSON.parse(cachedTestimonials));
        } else {
            // Cache expired or not found, fetch new data
            const fetchTestimonials = async () => {
                const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
                const Url = process.env.REACT_APP_API_TESTIMONIAL;
                try {
                    const response = await axios.get(`${apiBaseUrl}${Url}`);
                    setTestimonials(response.data);
                    localStorage.setItem(CACHE_KEY, JSON.stringify(response.data));
                    localStorage.setItem(CACHE_TIME_KEY, now.toString());
                } catch (error) {
                    console.error('Failed to fetch testimonials:', error);
                }
            };
            fetchTestimonials();
        }
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        fade: false,
        slidesToShow: 2,        // Show two slides at a time by default
        slidesToScroll: 1,      // Scroll two slides at a time by default
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: <button className="custom-prev">Prev</button>,
        nextArrow: <button className="custom-next">Next</button>,
        centerMode: false,
        responsive: [
            {
                breakpoint: 768, // Below 768px (typically tablets and mobile devices)
                settings: {
                    slidesToShow: 1,        // Show only one slide at a time
                    slidesToScroll: 1,      // Scroll one slide at a time
                },
            },
            {
                breakpoint: 1024, // For devices like tablets
                settings: {
                    slidesToShow: 2,        // Show two slides at a time
                    slidesToScroll: 2,      // Scroll two slides at a time
                },
            },
        ],
    };
    return (
        <div className="testimonial-area testimonial-bg pt-80 pb-60">
            <div className="container">
                <div className="row">
                    <div className="col-lg-7 mx-auto">
                        <div className="site-heading text-center wow fadeInDown" data-wow-delay=".25s">
                            <span className="site-title-tagline"><i className="far fa-passport"></i> ক্লায়েন্ট রিভিউ</span>
                            <h2 className="site-title text-white">ক্লায়েন্ট রিভিউ</h2>
                        </div>
                    </div>
                </div>
                <div className="carousel-container">
                    <div className="testimonial-slider wow fadeInUp" data-wow-delay=".25s">
                        <Slider {...settings}>
                            {testimonials.map((testimonial, index) => (
                                <div className="carousel-item" key={index}>
                                    <div className="testimonial-item mx-1">
                                        <div className="testimonial-quote-icon">
                                            <img src="assets/img/icon/quote.svg" alt="quote icon" />
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img width={70} src={`${backendBaseUrl}${testimonial?.image}`} alt={testimonial?.name} />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>{testimonial?.name}</h4>
                                            </div>
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>{testimonial?.message}</p>
                                        </div>
                                        <div className="testimonial-rate">
                                            {Array.from({ length: 5 }, (_, index) => {
                                                const starValue = index + 1;
                                                if (testimonial?.rating >= starValue) {
                                                    return <i key={starValue} className="fas fa-star filled" />;
                                                } else if (testimonial?.rating >= starValue - 0.5) {
                                                    return <i key={starValue} className="fas fa-star-half-alt filled" />;
                                                } else {
                                                    return <i key={starValue} className="fas fa-star" />;
                                                }
                                            })}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Testimonial;